export function reservePwaReload():boolean {
 try {
  const build=document.querySelector('meta[name="zoma-build"]')?.getAttribute('content')||'unversioned';
  const key=`zoma:pwa-reload:${build}`;
  if(sessionStorage.getItem(key))return false;
  sessionStorage.setItem(key,'1');return true;
 }catch{return false;} // Without persistent session state, never risk a reload loop.
}
export function registerServiceWorker(reload=()=>window.location.reload()){
 if(!('serviceWorker' in navigator))return;
 navigator.serviceWorker.addEventListener('controllerchange',()=>{
  if(navigator.serviceWorker.controller&&reservePwaReload())reload();
 });
 window.addEventListener('load',()=>{
  navigator.serviceWorker.register('/service-worker.js',{updateViaCache:'none'}).then(registration=>{
   // Explicitly revalidate the registration on every document load.
   void registration.update().catch(()=>{});
  }).catch(()=>{});
 });
}
